'use client';

import Link from 'next/link';
import styles from '../styles/TokenTermsLink.module.css';

const TokenTermsLink = () => {
  return (
    <div className={styles.termsLinkContainer}>
      <p className={styles.termsText}>
        See <Link href="/terms" className={styles.termsLink}>Token Sale Terms and Conditions</Link> for important information regarding the GAM token.
      </p>
    </div>
  );
};

export default TokenTermsLink; 